import React from 'react'
import { Link, graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import slugify from 'slugify'

/* COMPONENTS */
import InputSearch from './inputSearch'

/* STYLES */
import * as styles from './sideBarReceitas.module.scss'

/* ICONS */
import iconIg from '../../../images/home/instagram.svg'

const Cards = (props) => {
  const data = props.data
  return <>
    <Link to={`/receitas/${data.categoriaSlug}/${data.slug}/`} className='d-flex mb-4'>
      <div className='position-relative col-6 p-0 left-border-card'>
        <GatsbyImage
          image={data.image.localFile.childImageSharp.gatsbyImageData}
          className={`w-100 ${styles.cardHeight}`}
          alt='Card Receita' />
      </div>
      <div className='d-flex justify-content-start align-items-center right-border-card col-6 p-0'>
        <span className='text-dark mx-4 font-size-17'>{data.title}</span>
      </div>
    </Link>
  </>
}

const SideBarReceitas = () => {
  const data = useStaticQuery(
    graphql`{
  instaPost {
    permalink
    localFile {
      childImageSharp {
        gatsbyImageData(quality: 100, width: 500, height: 500, layout: CONSTRAINED)
      }
    }
  }
  acessadoUm: contentfulReceitas(slug: {eq: "pao-de-alho"}) {
    slug
    title
    categoriaSlug
    image {
      localFile {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH)
        }
      }
    }
  }
  acessadoDois: contentfulReceitas(slug: {eq: "milkshake-de-3-jeitos"}) {
    slug
    title
    categoriaSlug
    image {
      localFile {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH)
        }
      }
    }
  }
  acessadoTres: contentfulReceitas(slug: {eq: "3-molhos-para-frango"}) {
    slug
    title
    categoriaSlug
    image {
      localFile {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH)
        }
      }
    }
  }
  tags: allContentfulReceitas {
    edges {
      node {
        tagsReceitas
      }
    }
  }
}
`
  )

  const arrayseparado = []
  data.tags.edges.map(tags => {
    if (tags.node.tagsReceitas !== null) {
      tags.node.tagsReceitas.map(tag => {
        if (arrayseparado.some(value => value.tag.trim() === tag.trim())) {
          var index = arrayseparado.findIndex(i => i.tag.trim() === tag.trim())
          arrayseparado[index] = ({ tag: tag, qnt: arrayseparado[index].qnt + 1 })
        } else {
          arrayseparado.push({ tag: tag, qnt: 1 })
        }
      })
    }
  })

  arrayseparado.sort(function (a, b) { return b.qnt - a.qnt })

  return <>
    <div className='d-none d-sm-block' >
      <InputSearch />
    </div>
    <h3 className='text-uppercase text-red mb-2'>Receitas Famosas</h3>
    <Cards data={data.acessadoUm} />
    <Cards data={data.acessadoDois} />
    <Cards data={data.acessadoTres} />
    <h3 className='text-uppercase text-red'>Tags</h3>
    <div className='pb-1 row p-0 m-0'>
      {
        arrayseparado.map((tags, index) => {
          if (index < 11) {
            return (
              <Link to={`/receitas/tags/${slugify(tags.tag.toLowerCase())}/`} className='font-size-1125 bg-dia-gray text-dark rounded py-2 col-auto mb-2 mr-2' key={`tag${index}`}>
                {tags.tag} ({tags.qnt})
              </Link>
            )
          }
        })
      }
    </div>
    <div className='mb-4'>
      <Link to='/receitas/tags/'>
        <span className='text-blue font-size-13 text-underline pb-sm-1'>
          Ver todas as tags
        </span>
      </Link>
    </div>
    {data.instaPost &&
      <div className='d-none d-lg-block'>
        <h3 className="mt-4 mb-3 d-flex align-items-center text-red">
          <img src={iconIg} className="w-15 pr-3" alt="icone instagram" />
          Insta do Dia
        </h3>
        <a href={data.instaPost.permalink} target="_blank" rel="noreferrer" >
          <GatsbyImage
            image={data.instaPost.localFile.childImageSharp.gatsbyImageData}
            className={`${styles.instHeight} w-100`}
            alt="Banner Insta" />
        </a>
      </div>}
  </>
}

export default SideBarReceitas
